// extracted by mini-css-extract-plugin
export default {"wrapper":"F7eBH7uvuc0zOxNjQpo6","breadcrumb":"GMCzlKXh9y7E2UFs9VdG","titleWithCurrency":"hhXJsB98rJtnuEtaXPjp","title":"iTgtX5XOvMj8A4tOMSSk"};